import { Injectable, EventEmitter } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatModalInfoDialogComponent } from '../components/modais/mat-modal-info-dialog/mat-modal-info-dialog.component';
import { ModalConfirmComponent } from '../components/modais/modal-confirm/modal-confirm.component';
import { DataService } from './data.service';

declare var $:any;

@Injectable({
  providedIn: 'any',
})
export class AppService {

  public setStatusServidorEmitter = new EventEmitter();
  public emitChangePage           = new EventEmitter();
  public title:Title;
  public meta:Meta;
  public emitGetCategorias        = new EventEmitter();
  public emitSetCategorias        = new EventEmitter();
  public emitTest = new EventEmitter();

  constructor(
    title: Title,
    meta: Meta,
    private dialog: MatDialog,
    private data: DataService
  ) {
    this.title = title;
    this.meta  = meta;
  }
  
  /***
   * 
   * Load end
   * 
   */
  loadEnd(){

    $("#loader-page").css("display","none"); 

  }
  /**
   * 
   * get token
   * 
   */
  static getToken(){

    let token = $('#csrf-token').attr('content');   
    
    return token; 

  }
  /***
   * 
   * Gerar number
   * 
   */
  gerarNumber(limit=10){

    return Math.floor(Math.random() * limit);

  }
  /**
   * 
   * Formata as mensagens de erro 
   * 
   * @param err 
   * @param paxs 
   * 
   */
  getErrors(err,paxs=null){
    
    let messages = ""
    
    if(typeof(err) == "string"){
      messages = err
    }else{
      if(err.length > 1){
           
        for(let key in err) {
          if(paxs){
            let i = parseInt(key)+1 
            messages += "<h6>Passageiro: "+i+"<h6>"
          }
          for(let k in err[key]){
            messages += err[key][k]+"<br>"
          }
                   
        }
      }else{
        for(let key in err[0]) {
          messages += err[0][key]+"<br>"
        }
     }  
    
    }
    
    return messages
    
  }
  /**
   * 
   * Altera os dados das metas tags 
   * 
   * @param title 
   * @param description 
   * 
   */
  setMetaDados(title=null,description=null,keywords=null){
    
    //let nome   = AppSettings.NAME
    let nome   = "";
    let config = this.data.getConfiguracao(); 
    nome       = config.meta_title; 
    
    if(title != null){
      title = title; 
      this.title.setTitle(title);
    }else{
      this.title.setTitle(nome);
    }
    if(description != null){
      this.meta.updateTag({
        name: "description",
        content: description
      })
    }
    if(keywords != null){
      this.meta.updateTag({
        name: "keywords",
        content: keywords
      })
    }
    
  }
  /**
   * 
   * Insere as meta tags iniciais 
   * 
   * @param title 
   * @param description 
   * 
   */
  setMetaDadosInit(configuracao){

    this.title.setTitle(configuracao.meta_title);
    this.meta.updateTag({
      name: "description",
      content: configuracao.meta_description
    });

  }
  /**
   * 
   * Envia para a section
   * 
   * @param id 
   * 
   */
  toSection(id){
   
    var top = $(id).offset().top;
       
    $('html, body').stop().animate({ 
      scrollTop: top-100
    }, 500);
   

  }
  /**
   * 
   * Envia para o topo
   * 
   * 
   */
  toTop(){ 
         
    $('html, body').stop().animate({ 
      scrollTop: 0
    }, 500);
   

  }
  /**
   * 
   * Formata as mensagens de erro 
   * 
   * @param err 
   * @param paxs 
   * 
   */
  formarErrorsValidation(err,paxs=null){
    
    let messages = ""
    
    if(typeof(err) == "string"){
      messages = err
    }else{
      
      if(err.length > 1){
           
        for(let key in err) {
          if(paxs){
            let i = parseInt(key)+1 
            messages += "<h6>Passageiro: "+i+"<h6>"
          }
          for(let k in err[key]){
            messages += err[key][k]+"<br>"
          }
                   
        }
      }else{
        for(let key in err[0]) {
          messages += err[0][key]+"<br>"
        }
     }  
    
    }
    
    return messages
    
  }
  /**
   * 
   * Format errors passageiros
   * 
   */
  formartErrorsValidationPassageiros(passageiros){ 

    let html:any = ""; 

    for (let index = 0;index < passageiros.length;index++) {
      
      html += "<h3>"+passageiros[index].nome+"</h3>"; 

      for (let i = 0;i < passageiros[index].messages.length;i++) {
        html += "<h4>"+passageiros[index].messages[i].titulo+"</h4>";   
        html += this.formarErrorsValidation([passageiros[index].messages[i].errors]); 
      }  
      
    }

    return html;

  }
  /**
   * 
   * Formata o erro da API
   * 
   */
  formatError(response){ 


    let error = {
      status: null,
      statusText: null,
      message: null
    }

    let body = typeof(response._body) == "string" ? JSON.parse(response._body) : response;
    
    if(response.statusText){
      error.statusText = response.statusText;
    }
    if(response.status){
      error.status = response.status;
    }
    if(error.status == 405){
      error.message = "Método não permitido.";
    }
    if(typeof(body.error.errors) != "undefined" && error.message == null){
      
      if(error.status == 422){ 

        error.message = this.formarErrorsValidation([body.error.errors]);

      }else if(body.message){
        error.message = body.message;
      }

    }else{
      
      if(typeof(body.message) != "undefined"){
       error.message = body.message;
      }else if(typeof(body.exception) != "undefined"){
        error.message = body.exception;
      }else{
        error.message = response.data;
      }

    }

    return error;


  }
  /**
   * 
   * Formata a data da atividade
   * 
   * 
   */
  formatDateAtividade(date:string):string{

    let d = date.split("/");

    return d[2]+"-"+d[1]+"-"+d[0];
    
  }
  /**
   * 
   * Formata a tarifa da atividade
   * 
   * 
   */
  formatTarifaAtividade(tarifa:string):number{

    tarifa = tarifa.replace(new RegExp(/[.]/g),"");
    tarifa = tarifa.replace(new RegExp(/[,]/g),".");

    return parseFloat(tarifa);

  }
  /**
   * 
   * Info
   * 
   */
  info(message="",tipo='info',width='350px',height='auto'){

    this.dialog.open(MatModalInfoDialogComponent,{ 
      width: width,
      height: height,
      data:{
        message: message,
        tipo: tipo
      },
      panelClass: 'no-padding'
    });

  }
  /**
   * 
   * Info
   * 
   */
  confirm(
    message="",
    fnCallback=null,
    self=null,
    dataItem=null,
    width='350px',
    height='auto'
  ){
    
    this.dialog.open(ModalConfirmComponent,{ 
      width: width,
      height: height,
      data:{
        message: message,
        dataItem: dataItem,
        self: self,
        fnCallback: fnCallback
      },
      panelClass: 'no-padding'
    });
    
  }
  /**
   * 
   * Formatar Valor
   * 
   * @param value 
   * 
   */
  formatarValor(value){

    value = value.replace(new RegExp(/[.]/g),"");
    value = value.replace(new RegExp(/[,]/g),".");

    return parseFloat(value);

  }
  /**
   * 
   * Remove acentos
   * 
   */
  removerAcentos(value){

    var string = value;
    var mapaAcentosHex 	= {
        a : /[\xE0-\xE6]/g,
        A : /[\xC0-\xC6]/g,
        e : /[\xE8-\xEB]/g,
        E : /[\xC8-\xCB]/g,
        i : /[\xEC-\xEF]/g,
        I : /[\xCC-\xCF]/g,
        o : /[\xF2-\xF6]/g,
        O : /[\xD2-\xD6]/g,
        u : /[\xF9-\xFC]/g,
        U : /[\xD9-\xDC]/g,
        c : /\xE7/g,
        C : /\xC7/g,
        n : /\xF1/g,
        N : /\xD1/g
    };

    for ( var letra in mapaAcentosHex ) {
        var expressaoRegular = mapaAcentosHex[letra];
        string = string.replace( expressaoRegular, letra );
    }

    return string; 

  }
  /**
   * 
   * Forma a string para a URL
   * 
   */
  formatarApelido(value,withVirgula=true){

    value = value.toLowerCase();
    value = value.replace(new RegExp(/[\'~:;^`´'".,)(/]/g),"");
    if(withVirgula){
      value = value.replace(new RegExp(/[' ']/g),"-");
    }  
    value = value.replace(new RegExp(/[áãâà]/g),"a");
    value = value.replace(new RegExp(/[íìî]/g),"i");
    value = value.replace(new RegExp(/[éèê]/g),"e");
    value = value.replace(new RegExp(/[òóõô]/g),"o"); 
    value = value.replace(new RegExp(/[úùû]/g),"u");

    if(withVirgula){ 
      if(value != null && typeof(value) != "undefined"){
        
        let valueOut = "";
        
        for (let index = 0; index < value.length; index++) {
                
          let current = value[index];
          let next    = value.length < (index+1) ? null : value[index+1];
        
          if((current == "-" && next == "-") || (current == " " && next == "-") || (current == "-" && next == " ")){
            valueOut += ""; 
          }else{
            valueOut += current;
          }
              
        }
        
        value = valueOut;
        
      }
    }

    return value;

  }
  /**
   * 
   * Check mobile
   * 
   **/
  isMobile(){ 
   
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
  
  }

}
